import { useViewEvent } from 'features/events/context/ViewEvent';
import { useCheckout } from 'features/events/checkout/context';
import DiscountCode from '../DiscountCodeBanner';
import SubmitSelectionButton from '../SubmitSelectionButton';
import { useMemo } from 'react';
import OrderSummaryComponent from 'components/checkout/OrderSummary';

const OrderSummary = () => {
  const { event } = useViewEvent();
  const { appliedDiscount, tickets, ticketTiers, hasTierNav, user } =
    useCheckout();

  // Create array of ticket items from selected tickets
  const ticketItems = useMemo(() => {
    if (!tickets.selectedTicketTiers || !ticketTiers.data) {
      return [];
    }

    return Object.entries(tickets.selectedTicketTiers)
      .map(([tierId, ticketMetadata]) => {
        const tier = ticketTiers.data.find((tier) => tier._id === tierId);
        if (!tier) {
          return null;
        }

        return {
          id: tierId,
          quantity: ticketMetadata.quantity,
          title: tier.name,
          price: tier.price * ticketMetadata.quantity
        };
      })
      .filter(Boolean);
  }, [tickets.selectedTicketTiers, ticketTiers.data]);

  return (
    <OrderSummaryComponent
      hasTierNav={hasTierNav}
      isUserLoggedIn={!!user}
      discountData={appliedDiscount.data}
      tierRequiringApproval={!!tickets.tierRequiringApproval}
      selectedProducts={ticketItems}
      AdditionalOrderInfo={
        appliedDiscount.data && (
          <DiscountCode eventId={event._id} code={appliedDiscount.data.code} />
        )
      }
      Actions={<SubmitSelectionButton />}
    />
  );
};

export default OrderSummary;
